export const environment = {
  production: window.__env.production,
  cms_base_url: window.__env.cmsBaseUrl,
  trasparenza_base_url: window.__env.trasparenzaBaseUrl,
  api_base_url: window.__env.apiBaseUrl,
  endpointLastDate: window.__env.endpointLastDate,
  Keycloak_url: window.__env.keycloakUrl,
  adminPath: window.__env.adminPath,
  trasparenzaPath: window.__env.trasparenzaPath,
  allowPermissions: window.__env.allowPermissions,
  endpointPermission: window.__env.endpointPermission,
  endpointDragDropMenu: window.__env.endpointDragDropMenu
};